import React, { useState } from 'react';
import api from '../services/api';

const COURSE_TYPES = [
  { value: 'FULL_COURSE', label: 'Full Course' },
  { value: 'SPECIFIC_HOLE', label: 'Specific Hole' },
  { value: 'SECTION', label: 'Section' },
  { value: 'OTHER', label: 'Other' },
];

const Request: React.FC = () => {
  const [courseName, setCourseName] = useState('');
  const [courseType, setCourseType] = useState('FULL_COURSE');
  const [details, setDetails] = useState('');
  const [notify, setNotify] = useState(false);
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    if (notify && !email) {
      setError('Please enter your email to be notified.');
      setLoading(false);
      return;
    }
    try {
      await api.post('/email/suggest-course', {
        courseName,
        courseType,
        details,
        notify,
        email: notify ? email : undefined,
      });
      setSubmitted(true);
    } catch (err) {
      setError('There was a problem submitting your suggestion. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="max-w-lg mx-auto mt-12 bg-white p-8 rounded shadow text-center">
        <h2 className="text-2xl font-bold mb-4 text-green-700">Thank you!</h2>
        <p>Your suggestion has been submitted. If you are logged in, you will be notified when your course is ready to be ordered.</p>
      </div>
    );
  }

  return (
    <div className="max-w-lg mx-auto mt-12 bg-white p-8 rounded shadow">
      <h1 className="text-2xl font-bold mb-6 text-orange">Suggest a Course</h1>
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block mb-1 font-semibold">Course Name</label>
          <input
            type="text"
            className="w-full border px-3 py-2 rounded"
            value={courseName}
            onChange={e => setCourseName(e.target.value)}
            required
          />
        </div>
        <div>
          <label className="block mb-1 font-semibold">Type</label>
          <div className="flex gap-4">
            {COURSE_TYPES.map(type => (
              <label key={type.value} className="flex items-center gap-1">
                <input
                  type="radio"
                  name="courseType"
                  value={type.value}
                  checked={courseType === type.value}
                  onChange={() => setCourseType(type.value)}
                />
                {type.label}
              </label>
            ))}
          </div>
        </div>
        <div>
          <label className="block mb-1 font-semibold">Other Details</label>
          <textarea
            className="w-full border px-3 py-2 rounded"
            rows={4}
            value={details}
            onChange={e => setDetails(e.target.value)}
            placeholder="Any additional info (e.g. specific hole, section, or notes)"
          />
        </div>
        <div>
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={notify}
              onChange={e => setNotify(e.target.checked)}
            />
            Notify me when ready
          </label>
          {notify && (
            <input
              type="email"
              className="w-full border px-3 py-2 rounded mt-2"
              placeholder="Your email address"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required={notify}
            />
          )}
        </div>
        {error && <div className="text-red-600 text-sm">{error}</div>}
        <button
          type="submit"
          className="bg-orange text-white px-6 py-2 rounded font-bold hover:bg-logo-gray"
          disabled={loading}
        >
          {loading ? 'Submitting...' : 'Submit Suggestion'}
        </button>
      </form>
    </div>
  );
};

export default Request; 